import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _online, _cleanup, _setup;
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
// src/onlineManager.ts
import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";
var OnlineManager = (_online = /*#__PURE__*/new WeakMap(), _cleanup = /*#__PURE__*/new WeakMap(), _setup = /*#__PURE__*/new WeakMap(), class OnlineManager extends Subscribable {
  constructor() {
    super();
    _classPrivateFieldInitSpec(this, _online, {
      writable: true,
      value: true
    });
    _classPrivateFieldInitSpec(this, _cleanup, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _setup, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _setup, onOnline => {
      if (!isServer && window.addEventListener) {
        const onlineListener = () => onOnline(true);
        const offlineListener = () => onOnline(false);
        window.addEventListener("online", onlineListener, false);
        window.addEventListener("offline", offlineListener, false);
        return () => {
          window.removeEventListener("online", onlineListener);
          window.removeEventListener("offline", offlineListener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!_classPrivateFieldGet(this, _cleanup)) {
      this.setEventListener(_classPrivateFieldGet(this, _setup));
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldGet2;
      (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _cleanup)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.call(this);
      _classPrivateFieldSet(this, _cleanup, void 0);
    }
  }
  setEventListener(setup) {
    var _classPrivateFieldGet3;
    _classPrivateFieldSet(this, _setup, setup);
    (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _cleanup)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
    _classPrivateFieldSet(this, _cleanup, setup(this.setOnline.bind(this)));
  }
  setOnline(online) {
    const changed = _classPrivateFieldGet(this, _online) !== online;
    if (changed) {
      _classPrivateFieldSet(this, _online, online);
      this.listeners.forEach(listener => {
        listener(online);
      });
    }
  }
  isOnline() {
    return _classPrivateFieldGet(this, _online);
  }
});
var onlineManager = new OnlineManager();
export { OnlineManager, onlineManager };